import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "english-form__result" }
const _hoisted_2 = {
  key: 0,
  class: "english-form__success english-form__status"
}
const _hoisted_3 = {
  key: 1,
  class: "english-form__danger"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "english-form__danger english-form__status" }, " Ответ неверный! Возможно перевод этого слова раннее был введен неккоректно. ", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDone && !_ctx.isError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Молодец! Все верно! "))
      : _createCommentVNode("", true),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}